import { jsx as _jsx } from "react/jsx-runtime";
import { productsStore } from "../../../../stores/products/productsStore";
import { Box } from "@mui/material";
export const SetProductPagePagination = () => {
    productsStore.useGetPageItems();
    productsStore.useFilterData();
    return (_jsx(Box, { sx: { paddingTop: 2, paddingBottom: 1 } }, void 0));
};
//# sourceMappingURL=SetProductPagePagination.js.map